import { render, staticRenderFns } from "./NewSms.vue?vue&type=template&id=509ad304&scoped=true"
import script from "./NewSms.vue?vue&type=script&lang=js"
export * from "./NewSms.vue?vue&type=script&lang=js"
import style0 from "./NewSms.vue?vue&type=style&index=0&id=509ad304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ad304",
  null
  
)

export default component.exports